<template>
  <div v-show="question" class="plv-ia-answer-question-edit">
    <div class="plv-ia-answer-question-edit__top">
      <div class="plv-ia-answer-question-edit__section plv-ia-clearfix">
        <div class="plv-ia-answer-question-edit__label">{{ t('plvIA.answerCard.questionType') }}</div>
        <div class="plv-ia-answer-question-edit__content">
          <form-select
            v-model="type"
            :options-data="TYPE_TEXT"
            default-index="0"
          />
        </div>
      </div>

      <div class="plv-ia-answer-question-edit__section plv-ia-clearfix">
        <div class="plv-ia-answer-question-edit__label">{{ t('plvIA.answerCard.questionTitle') }}</div>
        <div class="plv-ia-answer-question-edit__content">
          <div class="plv-ia-answer-question-edit__input plv-ia-answer-question-edit__input--textarea">
            <div class="plv-ia-answer-question-edit__input__wrap plv-ia-answer-question-edit__input__wrap--textarea">
              <textarea
                ref="title"
                v-model.trim="name"
                :placeholder="t('plvIA.answerCard.enterTitle')"
                :maxlength="MAX_LEN.questionName"
              ></textarea>
              <span class="plv-ia-answer-question-edit__input-count plv-ia-answer-question-edit__input-count--textarea">{{ name.length }}/{{ MAX_LEN.questionName }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="plv-ia-answer-question-edit__section plv-ia-clearfix">
        <div class="plv-ia-answer-question-edit__label">{{ t('plvIA.answerCard.questionOption') }}</div>
        <div ref="option-list" class="plv-ia-answer-question-edit__content">
          <div
            v-for="(item, index) in options"
            :key="`options${index}`"
            class="plv-ia-answer-question-edit__options"
          >
            <div class="plv-ia-answer-question-edit__options__item plv-ia-clearfix">
              <div v-if="type === 'R'" class="plv-ia-answer-question-edit__input">
                <div class="plv-ia-answer-question-edit__input__wrap">
                  <form-radio v-model="answer" name="answer" :value="index | answerCode">
                    <input
                      ref="option"
                      v-model.trim="options[index]"
                      type="text"
                      data-type="option"
                      :maxlength="MAX_LEN.questionOption"
                      :placeholder="t('plvIA.answerCard.enterOption')"
                    />
                    <span class="plv-ia-answer-question-edit__input-count">{{ options[index].length }}/{{ MAX_LEN.questionOption }}</span>
                  </form-radio>
                </div>
              </div>

              <div v-if="type === 'C'" class="plv-ia-answer-question-edit__input">
                <div class="plv-ia-answer-question-edit__input__wrap">
                  <form-checkbox v-model="answer" name="answer" :value="index | answerCode">
                    <input
                      ref="option"
                      v-model.trim="options[index]"
                      type="text"
                      data-type="option"
                      :maxlength="MAX_LEN.questionOption"
                      :placeholder="t('plvIA.answerCard.enterOption')"
                    />
                    <span class="plv-ia-answer-question-edit__input-count">{{ options[index].length }}/{{ MAX_LEN.questionOption }}</span>
                  </form-checkbox>
                </div>
              </div>

              <div v-else-if="type === 'S'" class="plv-ia-clearfix">
                <input
                  ref="option"
                  v-model.trim="options[index]"
                  class="plv-ia-answer-question-edit__input plv-ia-answer-question-edit__input-score"
                  data-type="option"
                  type="text"
                  :placeholder="t('plvIA.answerCard.optionScore')"
                  @focus="handleScoreInputFocus($event, index)"
                  @blur="handleScoreInputBlur"
                />
                <input
                  v-model="tips[index]"
                  class="plv-ia-answer-question-edit__input plv-ia-answer-question-edit__input-tips"
                  data-type="tips"
                  type="text"
                  :placeholder="t('plvIA.answerCard.enterScorePrompt')"
                />
              </div>

              <div v-else-if="type === 'V'" class="plv-ia-answer-question-edit__input">
                <div class="plv-ia-answer-question-edit__input__wrap">
                  <input
                    ref="option"
                    v-model.trim="options[index]"
                    type="text"
                    data-type="option"
                    :maxlength="MAX_LEN.questionOption"
                    :placeholder="t('plvIA.answerCard.enterOption')"
                  />
                  <span class="plv-ia-answer-question-edit__input-count">{{ options[index].length }}/{{ MAX_LEN.questionOption }}</span>
                </div>
              </div>

              <div class="plv-ia-answer-question-edit__options-op-group">
                <i
                  v-show="options.length > 2"
                  class="plv-ia-answer-question-edit__options-op plv-ia-answer-question-edit__options-op--del"
                  @click="delOption(index)"
                ></i>
                <i
                  v-show="options.length < (type === 'R' || type === 'C' ? 15 : 5)"
                  class="plv-ia-answer-question-edit__options-op plv-ia-answer-question-edit__options-op--add"
                  @click="addOption(index)"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="plv-ia-answer-question-edit__bottom">
      <div class="plv-ia-answer-question-edit__bottom__right">
        <button class="plv-ia-btn-new plv-ia-btn-blue" @click="save">{{ t('plvIA.common.save') }}</button>
        <button class="plv-ia-btn-new" @click="cancel">{{ t('plvIA.common.cancel') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { AnswerCard } from '@polyv/interactions-launch-sdk';
import Locale from '@/mixins/locale';
import FormSelect from '@/components/form/Select';
import FormRadio from '@/components/form/Radio';
import FormCheckbox from '@/components/form/Checkbox';

export default {
  components: {
    FormSelect,
    FormRadio,
    FormCheckbox,
  },

  filters: {
    answerCode(index) {
      return String.fromCharCode(65 + index);
    }
  },
  mixins: [Locale],

  props: {
    question: {
      type: Object,
      default: null,
    },
    channelSetting: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      TYPE_TEXT: {
        R: this.t('plvIA.answerCard.oneChoiceLabel'),
        C: this.t('plvIA.answerCard.multipleChoiceLabel'),
        S: this.t('plvIA.answerCard.scoreLabel'),
        V: this.t('plvIA.answerCard.voteLabel')
      },
      MAX_LEN: AnswerCard.wordCountLimit,

      name: '',
      type: 'R',
      options: ['', ''],
      answer: '',
      tips: ['', ''],

      selfOptions: null,
      selfTips: null,
    };
  },

  watch: {
    question: {
      immediate: true,
      handler(data) {
        if (!data) return;

        const options = [];
        const tips = [];
        for (const key in data) {
          const optionTxt = data[key];
          // 四中账号的选项内容可以为空字符串，但其他账号选项内容不能为空字符串
          const isEmptyOption = this.channelSetting.answerContentBlankEnabled ? typeof optionTxt !== 'string' : !optionTxt;
          if (isEmptyOption && data.questionId !== '') continue;

          if (/^option\d{1,2}$/.test(key)) {
            options.push(optionTxt);
          }
          if (/^tips\d{1,2}$/.test(key)) {
            tips.push(optionTxt);
          }
        }

        this.options = options;
        this.tips = tips;
        this.type = data.type;
        if (data.questionId) {
          this.name = data.name;
        }
        if (data.type === 'C') {
          this.answer = data.answer.split('');
        } else {
          this.answer = data.answer;
        }
      }
    },

    type(newType, oldType) {
      this.answer = newType === 'C' ? [] : '';
      // 当从单选或多选切换到其他类型时，如果选项超过5，只保留前面5个
      if (newType !== 'R' && newType !== 'C' && this.options.length > 5) {
        this.options = this.options.slice(0, 5);
      }
      if (newType === 'S') {

        // 从其他类型切到评分题时，判断是否有存储selfOptions和selfTips
        this.tips = this.selfTips || this.options;
        this.options = this.selfOptions || this.options.map(() => '');
      } else if (oldType === 'S') {
        // 当评分题切换到其他类型时，存储当前options和tips状态
        this.selfOptions = JSON.parse(JSON.stringify(this.options));
        this.selfTips = JSON.parse(JSON.stringify(this.tips));

        // 当评分题切换到其他类型时，默认选项为2个
        this.options = this.tips.length >= 2 ? this.tips : ['', ''];

      }
    }
  },

  beforeDestroy() {
    this.clearTimer();
  },

  methods: {
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },

    handleScoreInputFocus(e, index) {
      const el = e.target;
      this.clearTimer();
      this.timer = setInterval(() => {
        // 限制输入框内容为最多3位的正整数
        this.options[index] = el.value = el.value.replace(/[^\d]/g, '').slice(0, 3);
      }, 500);
    },

    handleScoreInputBlur() {
      this.clearTimer();
    },

    delOption(curIndex) {
      this.options.splice(curIndex, 1);
      this.tips.splice(curIndex, 1);

      this.resetAnswer(curIndex, false);
    },

    resetAnswer(nextIndex, add) {
      if (this.type === 'R' && this.type === 'C') return;

      const isMultiple = this.type === 'C';
      let answerStr = isMultiple ? this.answer.join('') : this.answer;

      if (!add) {
        answerStr = answerStr.replace(String.fromCharCode(65 + nextIndex), '');
      }

      const answerArr = answerStr.split('');
      answerArr.forEach((item, itemIndex) => {
        const itemCode = item.charCodeAt();
        if (itemCode - 65 >= nextIndex) {
          const newItemCode = add ? itemCode + 1 : itemCode - 1;
          answerArr[itemIndex] = String.fromCharCode(newItemCode);
        }
      });
      this.answer = isMultiple ? answerArr : answerArr.join('');
    },

    addOption(curIndex) {
      const nextIndex = curIndex + 1;
      this.options.splice(nextIndex, 0, '');
      this.tips.splice(nextIndex, 0, '');

      this.resetAnswer(nextIndex, true);

      this.$nextTick(() => {
        const optionInputList = Array.prototype.filter.call(this.$refs['option-list'].getElementsByTagName('input'), (ele) => {
          return ele.type === 'text' && ele.getAttribute('data-type') === 'option';
        });
        optionInputList[nextIndex].focus();
      });
    },

    validateInput(question, options) {
      if (!question.name) {
        this.$iaMessage.default(this.t('plvIA.answerCard.enterTitle'));
        this.$refs.title.focus();
      } else if ((question.type === 'R' || question.type === 'C') && !question.answer) {
        this.$iaMessage.default(this.t('plvIA.answerCard.enterQuestionAnswer'));
      } else {
        // 判断选项内容是否为空（四中账号不做判断）
        if (this.channelSetting.answerContentBlankEnabled) return true;
        for (let index = 0; index < options.length; index++) {
          if (options[index]) continue;
          this.$iaMessage.default(this.t('plvIA.answerCard.enterOptions'));
          this.$refs.option[index].focus();
          return false;
        }
        return true;
      }
    },

    save() {
      const { options, tips } = this;
      const answer = this.type === 'C' ? this.answer.sort().join('') : this.answer;

      const question = {
        type: this.type,
        itemType: 0,
        name: this.name,
        answer: answer,
      };

      if (this.channelSetting.answerContentBlankEnabled && !question.name) { // 四中账号：题干为空时使用默认题干
        question.name = '请在屏幕上看老师提供的题目';
      }

      const validateResult = this.validateInput(question, options);
      if (!validateResult) return;

      for (let i = 1; i <= options.length; i++) {
        question[`option${i}`] = options[i - 1];
        if (this.channelSetting.answerContentBlankEnabled && question[`option${i}`] === '') { // 四中账号：选项内容为空时默认使用英文序号代替
          question[`option${i}`] = String.fromCharCode(64 + i);
        }
        question[`tips${i}`] = tips[i - 1];
      }

      if (this.question.questionId) {
        question.questionId = this.question.questionId;
      }

      this.$emit('save', question);
    },

    cancel() {
      this.$emit('cancel');
    }
  }
};
</script>

<style lang="scss">
@import '../../assets/styles/mixins.scss';

.plv-ia-answer-question-edit__input {
  @include input();
  width: 400px;

  &--textarea {
    padding: 0 2px;
  }

  .plv-ia-radio, .plv-ia-checkbox {
    height: 100%;
    width: 100%;
    margin: 0;
    vertical-align: top;
    position: relative;
    user-select: none;

    input[type=text] {
      line-height: 38px;
      width: 100%;
      box-sizing: border-box;
      padding-right: 4em;
      border: none;
      vertical-align: top;
    }
  }

  .plv-ia-radio >input+label {
    width: 100%;
    display: block;
    box-sizing: border-box;
    line-height: 38px;
    height: 100%;
  }

  .plv-ia-checkbox>label {
    line-height: 38px;
    height: 100%;
    width: 100%;
    display: block;
    box-sizing: border-box;
  }
}

.plv-ia-answer-question-edit__input__wrap {
  position: relative;

  &--textarea {
    padding-bottom: 22px;
    height: 100%;
    box-sizing: border-box;
  }
}

.plv-ia-answer-question-edit__input-count {
  position: absolute;
  bottom: 0;
  right: 0;
  line-height: 38px;
  font-size: 12px;
  color: #9E9E9E;
  user-select: none;

  &--textarea {
    line-height: 22px;
    right: 8px;
  }
}

.plv-ia-answer-question-edit__options__item {
  margin-bottom: 20px;
  position: relative;

  >div {
    float: left;
  }
}

.plv-ia-answer-question-edit__options-op-group {
  line-height: 40px;
  height: 32px;
  font-size: 0;
  margin-left: 4px;
}

.plv-ia-answer-question-edit__options-op {
  display: inline-block;
  width: 16px;
  height: 16px;
  padding: 12px 4px;
  background-origin: content-box;
  background-repeat: no-repeat;
  background-size: contain;
  vertical-align: top;
  cursor: pointer;
  box-sizing: content-box;

  &:first-child {
    padding-left: 4px;
  }

  &--del {
    background-image: url(./images/icon-del.png);

    &:hover {
      background-image: url(./images/icon-del-hover.png);
    }

    &:active {
      background-image: url(./images/icon-del-active.png);
    }
  }

  &--add {
    background-image: url(./images/icon-add.png);

    &:hover {
      background-image: url(./images/icon-add-hover.png);
    }

    &:active {
      background-image: url(./images/icon-add-active.png);
    }
  }
}

.plv-ia-answer-question-edit__bottom__right {
  float: right;

  button {
    width: 64px;

    & +button {
      margin-left: 12px;
    }
  }
}

.plv-ia-answer-question-edit__input-score {
  width: 110px;
  float: left;
  margin-right: 20px;
}

.plv-ia-answer-question-edit__input-tips {
  width: 270px;
  float: left;
}
</style>
